import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Lightning, ArrowRight } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login } = useAuth();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [busy,     setBusy]     = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    const result = await login(email.trim(), password);
    if (!result.ok) { setError(result.error); setBusy(false); }
  };

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <div className="w-8 h-8 rounded-md bg-slate-900 flex items-center justify-center">
            <Lightning weight="fill" className="text-white" size={16} />
          </div>
          <div>
            <div className="font-display font-bold text-slate-900 leading-none tracking-tight">
              Tembo Intelligence
            </div>
            <div className="data-label mt-0.5">Insight Evolution OS</div>
          </div>
        </div>

        {/* Form card */}
        <div className="surface rounded-xl p-8 shadow-sm">
          <div className="data-label mb-1">Access</div>
          <h1 className="font-display text-2xl font-bold text-slate-900 mb-0.5">Sign in</h1>
          <p className="text-sm text-slate-500 mb-6 leading-relaxed">
            Intelligence that evolves through evidence and discussion.
          </p>

          <form onSubmit={submit} className="flex flex-col gap-4" data-testid="login-form">
            <div>
              <label className="data-label mb-1.5 block">Email</label>
              <input
                type="email" value={email} required autoFocus
                data-testid="login-email-input"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full px-3 py-2.5 border border-slate-200 rounded-md text-sm
                           focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 transition"
              />
            </div>
            <div>
              <label className="data-label mb-1.5 block">Password</label>
              <input
                type="password" value={password} required
                data-testid="login-password-input"
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2.5 border border-slate-200 rounded-md text-sm
                           focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 transition"
              />
            </div>

            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                {error}
              </div>
            )}

            <button
              type="submit" disabled={busy}
              data-testid="login-submit-btn"
              className="w-full bg-slate-900 hover:bg-slate-800 text-white font-medium text-sm
                         py-2.5 rounded-md transition-colors flex items-center justify-center gap-2
                         disabled:opacity-60 mt-1"
            >
              {busy ? "Signing in…" : "Continue"} <ArrowRight size={14} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
